export default __webpack_public_path__ + "static/media/XamColor928.2a214f27.jpg";